module.exports = __webpack_public_path__ + "img/icon-settings-modelo.4ce6403e.svg";